import { useState } from "react";

export function useDescriptionSection(initial = "") {
  const [notaAdicional, setNotaAdicional] = useState<string>(initial);

  const reset = () => setNotaAdicional("");

  return {
    notaAdicional,
    setNotaAdicional,
    reset,
  };
}
